// ------------------------------------
// Funções Úteis
// ------------------------------------

// Debounce (Melhora a performance de funções repetitivas como "Scroll / Resize")
const debounce = function (n, t, u) {
  var e;
  return function () {
    var a = this,
      i = arguments,
      o = function () {
        (e = null), u || n.apply(a, i);
      },
      r = u && !e;
    clearTimeout(e), (e = setTimeout(o, t)), r && n.apply(a, i);
  };
};

// Verifica o tamanho da tela de acordo com o tipo passado
function isMedia(media) {
  media = media.trim().toLowerCase();
  const size = $(window).width();
  const validations = {
    xs: size <= 480,
    sm: size > 480 && size <= 768,
    md: size > 768 && size <= 945,
    lg: size > 940 && size <= 1280,
    xl: size > 1280,
  };
  return validations[media];
}

// Retorna o tamanho da tela
function getMedia() {
  const sizes = ['xs', 'sm', 'md', 'lg', 'xl'];
  return sizes.filter((sizeItem) => isMedia(sizeItem))[0];
}

// Copia uma string para a área de transferência
function copyToClipboard(str) {
  const el = document.createElement('textarea');
  el.value = str;
  el.setAttribute('readonly', '');
  el.style.position = 'absolute';
  el.style.left = '-9999px';
  document.body.appendChild(el);
  const selected = document.getSelection().rangeCount > 0 ? document.getSelection().getRangeAt(0) : false;
  el.select();
  document.execCommand('copy');
  document.body.removeChild(el);
  if (selected) {
    document.getSelection().removeAllRanges();
    document.getSelection().addRange(selected);
  }
}

// Valida CPF
function isValidCPF(r) {
  var t, a, n, e, i;
  if (((i = 1), (r = r.replace(/[^\d]+/g, '')).length != 11)) return !1;
  for (e = 0; e < r.length - 1; e++)
    if (r.charAt(e) != r.charAt(e + 1)) {
      i = 0;
      break;
    }
  if (i) return !1;
  for (t = r.substring(0, 9), a = r.substring(9), n = 0, e = 10; e > 1; e--) n += t.charAt(10 - e) * e;
  if ((n % 11 < 2 ? 0 : 11 - (n % 11)) != a.charAt(0)) return !1;
  for (t = r.substring(0, 10), n = 0, e = 11; e > 1; e--) n += t.charAt(11 - e) * e;
  return (n % 11 < 2 ? 0 : 11 - (n % 11)) == a.charAt(1);
}

// Valida CNPJ
function isValidCNPJ(r) {
  if ('' == (r = r.replace(/[^\d]+/g, ''))) return !1;
  if (14 != r.length) return !1;
  if (
    '00000000000000' == r ||
    '11111111111111' == r ||
    '22222222222222' == r ||
    '33333333333333' == r ||
    '44444444444444' == r ||
    '55555555555555' == r ||
    '66666666666666' == r ||
    '77777777777777' == r ||
    '88888888888888' == r ||
    '99999999999999' == r
  )
    return !1;
  for (var t = r.length - 2, n = r.substring(0, t), a = r.substring(t), e = 0, i = t - 7, u = t; u >= 1; u--)
    (e += n.charAt(t - u) * i--), i < 2 && (i = 9);
  var f = e % 11 < 2 ? 0 : 11 - (e % 11);
  if (f != a.charAt(0)) return !1;
  for (t += 1, n = r.substring(0, t), e = 0, i = t - 7, u = t; u >= 1; u--)
    (e += n.charAt(t - u) * i--), i < 2 && (i = 9);
  return (f = e % 11 < 2 ? 0 : 11 - (e % 11)) == a.charAt(1);
}

// Valida CPF ou CNPJ
function isValidCPForCNPJ(value) {
  return isValidCPF(value) || isValidCNPJ(value);
}

// Formata um valor para real (R$)
function formatMoneyBR(v, c, d, t) {
  var n = v,
    c = isNaN((c = Math.abs(c))) ? 2 : c,
    d = d == undefined ? ',' : d,
    t = t == undefined ? '.' : t,
    s = n < 0 ? '-' : '',
    i = parseInt((n = Math.abs(+n || 0).toFixed(c))) + '',
    j = (j = i.length) > 3 ? j % 3 : 0;
  return (
    s +
    (j ? i.substr(0, j) + t : '') +
    i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + t) +
    (c
      ? d +
        Math.abs(n - i)
          .toFixed(c)
          .slice(2)
      : '')
  );
}

// Formata um valor em real (R$) para o formato do banco
function formatMoneyBD(value) {
  return value.replace('.', '').replace(',', '.');
}

// Obtém a largura de um texto em pixels
function measureText(string, fontSize = 14, fontWeight = 400) {
  const $el = $('<div></div>');
  $el.css({
    position: 'absolute',
    top: -1000,
    left: -1000,
    visibility: 'hidden',
    'white-space': 'nowrap',
    'font-size': fontSize,
    'font-weight': fontWeight,
  });
  $el.text(string);
  $('body').append($el);
  const textWidth = $el.width();
  $el.remove();
  return textWidth;
}

// Remove tags html de uma string
function stripTags(string) {
  return string.replace(/<(.|\n)*?>/g, '');
}

// Remove o que não for número de uma string
function somenteNumeros(string) {
  return string.replace(/\D/g, '');
}

// Converte um texto markdown para html
function mdParse(string, inline = false) {
  if (!string) {
    string = '';
  }
  return !inline ? marked(string.trim()) : marked.parseInline(string.trim());
}

// Obtém a extensão de um arquivo
function getFileExt(fileName) {
  return fileName.split('.')[fileName.split('.').length - 1].toLowerCase();
}

// Gera um número aleatório
function randomNumber(min, max) {
  return Math.floor(Math.random() * (max - min + 1) + min);
}

// Gera um slug
function slugify(text) {
  return text
    .toString()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '-')
    .replace(/[^\w-]+/g, '')
    .replace(/--+/g, '-');
}

// Gera o token aleatório
function generateToken(n = 10) {
  const chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  let token = '';
  for (let i = 0; i < n; i++) {
    token += chars[Math.floor(Math.random() * chars.length)];
  }
  return token + '-' + Date.now();
}

// Corrige o bug da altura do slick com altura automática
function slickFixHeight($el) {
  if ($el.length > 0) {
    setTimeout(() => {
      const curSlideHeight = $el.find('.slick-current').outerHeight();
      $el.find('.slick-list.draggable').height(curSlideHeight);
    }, 100);
  }
}
